
import Vue from 'vue'

export default Vue.extend({
  head(): any {
    const title = this.App.state.current?.title
    const titleTemplate = title ? '%s - ' + process.env.APPLICATION_NAME : null

    return {
      title,
      titleTemplate
    }
  },
  created() {
    this.App.state.layout = 'legacy'
  }
})
